// extracted by mini-css-extract-plugin
export default {"part1":"Qc_part1__My0PZ","first":"Qc_first__uqvGf","second":"Qc_second__4Ie9w","third":"Qc_third__ZxsX3","inner1":"Qc_inner1__DNZjo","inner2":"Qc_inner2__QvsCW"};